module.exports = __webpack_public_path__ + "static/media/hamburger.98aae47d.svg";